import { render, staticRenderFns } from "./RecipeTabsUpdate.vue?vue&type=template&id=ba2fa1c0&"
import script from "./RecipeTabsUpdate.vue?vue&type=script&lang=js&"
export * from "./RecipeTabsUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports